import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Input,
  Text,
  Heading
} from '@sparrowengg/twigs-react';
import {
  PlusIcon,
  SearchIcon,
  ChevronRightIcon
} from '@sparrowengg/twigs-react-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from '@sparrowengg/twigs-react';
import Apps from 'features/apps';
import Webhook from 'features/webhook';
import ConfigPage from 'pages/config-page';
import AppsIcon from 'commons/icons/apps';
import IntegrateIcon from 'commons/icons/integrate';
import DocumentationBanner from 'commons/components/documentation-banner';
import { SingleAppDetails, WebhookDetailsType } from '../types';
import { currentTabValues } from '../constants';

const Dashboard = ({
  isConfigPage,
  setIsConfigPage
}: {
  isConfigPage: boolean;
  setIsConfigPage: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultTab =
    new URLSearchParams(location.search).get('tab') ?? currentTabValues.APPS;
  const [currentTab, setCurrentTab] = useState(defaultTab);
  const [webhookList, setWebhookList] = useState<Array<WebhookDetailsType>>([]);
  const [apps, setApps] = useState<Array<SingleAppDetails>>([]);
  const [inputSearch, setInputSearch] = useState('');

  const isAppsPage = currentTab.includes(currentTabValues.APPS);

  const handleConfigPage = (configPage: boolean) => {
    setIsConfigPage(configPage);
  };

  return (
    <Box css={{ padding: '$20 $40' }}>
      {isConfigPage ? (
        <ConfigPage />
      ) : (
        <>
          <DocumentationBanner />
          <Tabs defaultValue={currentTab}>
            <Flex justifyContent="space-between" alignItems="center">
              <Flex gap="$2">
                <Flex
                  alignItems="center"
                  gap="$4"
                  onClick={() => {
                    setCurrentTab(currentTabValues.APPS);
                    setInputSearch('');
                  }}
                  css={{
                    background: isAppsPage
                      ? 'rgba(74, 156, 166, 0.08)'
                      : 'transparent',
                    borderRadius: '$lg',
                    padding: '$4',
                    cursor: 'pointer',
                    ...(isAppsPage && {
                      borderBottom: '$borderWidths$sm solid $primary400'
                    })
                  }}
                >
                  <AppsIcon
                    size={'20'}
                    color={isAppsPage ? '#4A9CA6' : '#6A6A6A'}
                  />
                  <Text
                    weight="medium"
                    size="sm"
                    css={{ color: isAppsPage ? '$primary600' : '$neutral900' }}
                  >
                    {' '}
                    Apps
                  </Text>
                </Flex>
                <Flex
                  alignItems="center"
                  gap="$4"
                  onClick={() => {
                    setCurrentTab(currentTabValues.WEBHOOK);
                    setInputSearch('');
                  }}
                  css={{
                    background: !isAppsPage
                      ? 'rgba(74, 156, 166, 0.08)'
                      : 'transparent',
                    borderRadius: '$lg',
                    padding: '$4',
                    cursor: 'pointer',
                    ...(!isAppsPage && {
                      borderBottom: '$borderWidths$sm solid $primary400'
                    })
                  }}
                >
                  <IntegrateIcon
                    size={'20'}
                    color={!isAppsPage ? '#4A9CA6' : '#6A6A6A'}
                  />
                  <Text
                    weight="medium"
                    size="sm"
                    css={{ color: !isAppsPage ? '$primary600' : '$neutral900' }}
                  >
                    {' '}
                    Global Webhooks
                  </Text>
                </Flex>
              </Flex>
              <Flex alignItems="center" gap="$8">
                <Input
                  placeholder="Search Applications"
                  size="lg"
                  value={inputSearch}
                  onChange={(e) => setInputSearch(e.currentTarget.value)}
                  css={{ width: 320 }}
                  leftIcon={<SearchIcon />}
                />
                <Button
                  color="primary"
                  size="lg"
                  rightIcon={<PlusIcon />}
                  onClick={() =>
                    isAppsPage
                      ? handleConfigPage(true)
                      : navigate('/add-webhook')
                  }
                >
                  {`New ${isAppsPage ? 'App' : 'Webhook'}`}
                </Button>
              </Flex>
            </Flex>
            {currentTab === currentTabValues.APPS ? (
              <Apps
                apps={apps}
                inputSearch={inputSearch}
                setApps={setApps}
                handleConfigPage={handleConfigPage}
              />
            ) : (
              <Webhook
                webhookList={webhookList}
                setWebhookList={setWebhookList}
                inputSearch={inputSearch}
              />
            )}
          </Tabs>
        </>
      )}
    </Box>
  );
};

export default Dashboard;
